import clsAuthApi from '@/app/clsAuthApi'

let obj = new clsAuthApi();

export default obj;

